module.exports = __webpack_public_path__ + "static/dark-b3fcd00ec3840a5c9707c9f17cef7d27.png";